export class VehicleTypeDto {

  public id!: string;
  public name!: string;
  public sort!: number;

  constructor(init?: Partial<VehicleTypeDto> | undefined) {
    Object.assign(this, init);
  }
}
